import { UI } from 'common';
import React from 'react';
import { FilterType } from './FilterType.enum';

const { WrappedButton, WrappedButtonType } = UI;

const EmptyProductsGrid = ({ onClickAddProductCallback, activeMenuItemId }) => {
	const filterBy = activeMenuItemId.split('_')[0];

	const renderNoProducts = () => (
		<>
			<p className="grid-title">
				You have no <b>Products</b> to view
			</p>
			<p>
				We add products as orders come in, and from there you can assign
				shipping preferences or decide how they should appear on customs forms.
			</p>
			<p>
				Alternatively, add products manually to set them up before an order
				import.
			</p>
			<div>
				<WrappedButton
					label="Add a Product"
					onClick={onClickAddProductCallback}
					buttonType={WrappedButtonType.Primary}
					dataqa="products-grid-add-product"
				/>
				<span>Add a blank product and fill in the details manually.</span>
			</div>
		</>
	);

	return (
		<div className="products products-empty-products-grid">
			{filterBy === FilterType.Search && (
				<div className="no-match-products">No products match your search</div>
			)}
			{filterBy === FilterType.Category && (
				<div className="no-match-products">
					No products match the selected category
				</div>
			)}
			{filterBy === FilterType.Tag && (
				<div className="no-match-products">
					No products match the selected tag
				</div>
			)}
			{filterBy === FilterType.All && renderNoProducts()}
		</div>
	);
};

export default EmptyProductsGrid;
